import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import {NavigateFunction} from "react-router-dom";

import {apiRequestLibrary} from "../../api/apiRequests";
import {checkRedirect} from "../login/RequireAuth";
import {defaultPagination, PaginationInterface} from "../ui/Pagination";

export interface EBook {
  title: string,
  image?: string,
  description?: boolean,
  downloadUrl?: string,
}
export interface eLibraryState {
  eBooks: EBook[],
  eBooksStatus: string,
  pagination: PaginationInterface,
}

const initialState: eLibraryState = {
  eBooks: [],
  eBooksStatus: "",
  pagination: {...defaultPagination}
}

export const fetchEbooks = createAsyncThunk(
  'ebooks/get',
  async (params: {navigate: NavigateFunction, currentPage: number, postsPerPage: number}) => {
    const {currentPage, postsPerPage} = params;
    // const response = await get("books.json");
    const response = await apiRequestLibrary(currentPage, postsPerPage);
    await checkRedirect(params, response);
    return {
      eBooks: response.data || [],
      pagination: response.pagination || {},
    };
  },
)

export const eLibrarySlice = createSlice({
  name: 'eLibrary',
  initialState,
  reducers: {
    // increment: (state) => {
    //   // Redux Toolkit allows us to write "mutating" logic in reducers. It
    //   // doesn't actually mutate the state because it uses the Immer library,
    //   // which detects changes to a "draft state" and produces a brand new
    //   // immutable state based off those changes
    //   state.value += 1
    // },
    // decrement: (state) => {
    //   state.value -= 1
    // },
    // incrementByAmount: (state, action: PayloadAction<number>) => {
    //   state.value += action.payload
    // },
    setEBooksPaginationPage: (state, action: PayloadAction<number>) => {
      state.pagination.currentPage = action.payload;
    },
    clearEbooks: (state) => {
      state.eBooks = [];
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchEbooks.pending, (state) => {
        state.eBooksStatus = "loading"
      })
      .addCase(fetchEbooks.fulfilled, (state, action) => {
        state.eBooksStatus = "succeeded"
        state.eBooks = action.payload.eBooks;
        if (action.payload.pagination?.totalPages) {
          state.pagination.totalPages = action.payload.pagination.totalPages;
        }
        if (action.payload.pagination?.totalRecords) {
          state.pagination.totalRecords = action.payload.pagination.totalRecords;
        }
      })
      .addCase(fetchEbooks.rejected, (state) => {
        state.eBooksStatus = "failed"
      })
      // .addCase(deletePost.fulfilled, (state, action) => {
      //   if (!action?.payload.id) {
      //     console.log("could not delete");
      //     console.log(action.payload)
      //     return
      //   }
      //
      //   const { id } = action.payload;
      //   const OldPosts = state.posts.filter(post =>
      //     post.id !== id)
      //   state.posts = OldPosts
      // })
  }
});

export const { setEBooksPaginationPage, clearEbooks } = eLibrarySlice.actions;

export default eLibrarySlice.reducer